import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_BACKEND_API_BASE_URL;

class PlotService {
  getPlotById(plot_id){
    return axios.get(API_URL + 'plot/' + plot_id, { headers: authHeader() })
    .then(response => {
      return response.data; 
    });
  }

  createPlot(plot_model){
    return axios.post(API_URL + 'plot/', plot_model, {headers: authHeader()})
    .then(response=>{
      return response.data;
    });
  }

  updatePlotById(plot_id, plot_model){
    return axios.patch(API_URL + 'plot/'+plot_id, plot_model, {headers: authHeader()})
    .then(response=>{
      return response.data;
    });
  }

  updatePlotParamsById(plot_id, plot_params){
    return axios.patch(API_URL + 'plot/'+plot_id+'/params/update', {params: plot_params}, {headers: authHeader()})
    .then(response=>{
      return response.data;
    });
  }

  deletePlotById(plotId){
    return axios.delete(API_URL + 'plot/'+plotId, {headers: authHeader()})
    .then(response=>{
      return response.data
    })
  }
}

export default new PlotService();